// src/MuhtarDashboard.js
import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './components/ui/card';
import { Button } from './components/ui/button';
import { API_BASE, ORIGIN_BASE } from './config';


/* ---------- Basit i18n (yapıyı bozmadan) ---------- */
const I18N = {
  tr: {
    adminPanel: 'Admin Paneli',
donations: 'Ana Kategoriler',
    users: 'Kullanıcılar',
    announcements: 'Duyurular',
    events: 'Etkinlikler',
news: 'Geri Bildirim',
    activities: 'Faaliyetler',
    recentAnnouncements: '📢 Son Duyurular',
    upcomingEvents: '📆 Yaklaşan Etkinlikler',
    detail: 'Detay ↗',
    addAnnouncement: '➕ Duyuru Ekle',
    createEvent: '📅 Etkinlik Oluştur',
  },
  en: {
    adminPanel: 'Admin Panel',
  donations: 'Main Categories',
    users: 'Users',
    announcements: 'Announcements',
    events: 'Events',
    news: 'News',
    activities: 'Activities',
    recentAnnouncements: '📢 Latest Announcements',
    upcomingEvents: '📆 Upcoming Events',
    detail: 'Details ↗',
    addAnnouncement: '➕ Add Announcement',
    createEvent: '📅 Create Event',
  },
  de: {
    adminPanel: 'Admin-Panel',
  donations: 'Hauptkategorien',
    users: 'Benutzer',
    announcements: 'Ankündigungen',
    events: 'Veranstaltungen',
    news: 'Nachrichten',
    activities: 'Aktivitäten',
    recentAnnouncements: '📢 Neueste Ankündigungen',
    upcomingEvents: '📆 Bevorstehende Veranstaltungen',
    detail: 'Details ↗',
    addAnnouncement: '➕ Ankündigung hinzufügen',
    createEvent: '📅 Veranstaltung erstellen',
  },
};

const getLang = () => {
  const fromApp = (localStorage.getItem('app_lang') || '').toLowerCase();
  const fromLang = (localStorage.getItem('lang') || '').toLowerCase();
  const nav = ((navigator.language || 'tr').slice(0, 2) || 'tr').toLowerCase();
  const candidate = fromApp || fromLang || nav;
  return ['tr', 'en', 'de'].includes(candidate) ? candidate : 'tr';
};

const localeToDate = { tr: 'tr-TR', en: 'en-US', de: 'de-DE' };
/* -------------------------------------------------- */

const MuhtarDashboard = () => {
const token = localStorage.getItem('token');

  const [duyurular, setDuyurular] = useState([]);
  const [etkinlikler, setEtkinlikler] = useState([]);
const [anakategoriler, setAnaKategoriler] = useState([]);
const [geribildirim, setGeriBildirim] = useState([]);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [faaliyetler, setFaaliyetler] = useState([]);

  // 🔤 Dil durumu
  const [lang, setLang] = useState(getLang());
  const t = (key) => (I18N[lang] && I18N[lang][key]) || key;
  const dateLocale = localeToDate[lang] || 'tr-TR';

  useEffect(() => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

   fetch(`${API_BASE}/duyurular`, { headers })
      .then(res => res.json())
      .then(data => {
        const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        setDuyurular(list);
      });

    fetch(`${API_BASE}/etkinlikler`, { headers })
      .then(res => res.json())
      .then(data => {
        const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        setEtkinlikler(list);
      });

   fetch(`${API_BASE}/anakategoriler`, { headers })
  .then(res => res.json())
  .then(data => {
    const list = Array.isArray(data?.data) ? data.data : [];
    setAnaKategoriler(list);
  })

fetch(`${API_BASE}/geribildirimler`, { headers })
  .then(res => res.json())
  .then(data => {
    const list = Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data)
      ? data
      : [];
    setGeriBildirim(list);
  });


fetch(`${API_BASE}/kullanicilar`, { headers })
  .then(res => res.json())
  .then(data => {
    const list = Array.isArray(data?.data) ? data.data : [];
    setKullanicilar(list);
  });


   fetch(`${API_BASE}/faaliyetler`, { headers })
  .then(res => res.json())
  .then(data => {
    const list = Array.isArray(data?.data) ? data.data : [];
    setFaaliyetler(list);
  });


    // Depolama değişimi (diğer sekmelerde) ve aynı sekmede anlık değişim
    const onStorage = (e) => {
      if (e.key === 'app_lang' || e.key === 'lang') setLang(getLang());
    };
    const onAppLangChange = () => setLang(getLang());

    window.addEventListener('storage', onStorage);
    window.addEventListener('app_lang_change', onAppLangChange);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('app_lang_change', onAppLangChange);
    };
  }, []);

useEffect(() => {
  // 🔴 Kurum / token değiştiği anda eski verileri temizle
  setDuyurular([]);
  setEtkinlikler([]);
  setAnaKategoriler([]);
  setGeriBildirim([]);
  setKullanicilar([]);
  setFaaliyetler([]);
}, [token]);


  const DashboardCard = ({ count, label, color, href }) => (
    <div className={`${color} text-white rounded-lg p-6 shadow-md`}>
      <div className="text-3xl font-bold">{count}</div>
      <div className="text-sm mt-2">{label}</div>
      <a href={href} className="mt-2 text-xs underline cursor-pointer block">{t('detail')}</a>
    </div>
  );

  return (
    <div className="ml-[10px] p-8 overflow-y-auto">
      <h1 className="text-2xl font-bold mb-6">{t('adminPanel')}</h1>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-10">
<DashboardCard 
  count={anakategoriler.length} 
  label={t('donations')} 
color="bg-orange-400"
  href="#/anakategoriler" 
/>
<DashboardCard 
  count={kullanicilar.length} 
  label={t('users')} 
  color="bg-blue-600" 
  href="#/kullanicilar" 
/>

        <DashboardCard count={duyurular.length} label={t('announcements')} color="bg-purple-600" href="#/duyurular" />
        <DashboardCard count={etkinlikler.length} label={t('events')} color="bg-red-600" href="#/etkinlikler" />

<DashboardCard 
  count={geribildirim.length} 
  label={t('news')}
  color="bg-yellow-700" 
  href="#/geribildirimler" 
/>

<DashboardCard 
  count={faaliyetler.length} 
  label={t('activities')} 
  color="bg-green-600" 
  href="#/faaliyetler" 
/>

      </div>

      {/* Son Duyurular */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-4">{t('recentAnnouncements')}</h2>
        <div className="grid gap-4">
          {duyurular.slice(0, 3).map((d) => (
            <Card key={d.id}>
              <CardContent className="p-4">
                <h3 className="font-bold">{d.baslik}</h3>
                <p className="text-sm text-gray-600">
                  {d.tarih ? new Date(d.tarih).toLocaleDateString(dateLocale) : ''}
                </p>
                <p className="mt-1 text-sm">{d.aciklama}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* Yaklaşan Etkinlikler */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-4">{t('upcomingEvents')}</h2>
        <div className="grid gap-4">
          {etkinlikler.slice(0, 3).map((e) => (
            <Card key={e.id}>
              <CardContent className="p-4">
                <h3 className="font-bold">{e.baslik}</h3>
                <p className="text-sm text-gray-600">
                  {e.tarih ? new Date(e.tarih).toLocaleDateString(dateLocale) : ''}
                </p>
                <p className="mt-1 text-sm">{e.aciklama}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* Butonlar */}
      <div className="flex gap-4">
        <Button onClick={() => (window.location.hash = '#/duyurular')}>
          {t('addAnnouncement')}
        </Button>
        <Button onClick={() => (window.location.hash = '#/etkinlikler')}>
          {t('createEvent')}
        </Button>
      </div>
    </div>
  );
};

export default MuhtarDashboard;
